import type { ChartAdditionalParams } from 'shared/domain/analytics/chartModel';
import { requireVisibleProcesses } from '../model';
import { get as getImpacts } from 'serviceWorker/db/fieldValues/impacts/impacts';
import { IssueEntity } from 'serviceWorker/repository/issue/entity';
import {
  ChartValuesAndLabels,
  FilterValues,
  IssueChart,
} from 'shared/types/analytics';
import { HashMap, LabelledEntity } from 'shared/types/commonView';
import {
  increaseEntitySeries,
  increaseNoneSeries,
  toSortedValuesAndLabels,
} from '../seriesCreation';
import { filterIssuesByChartFilters } from '../issueChartFilters';

export async function createSeriesAndLabelsFromIssuesWithFilters(
  issues: IssueEntity[],
  filters: FilterValues,
  timezone: string,
  additionalParams: ChartAdditionalParams | undefined
): Promise<ChartValuesAndLabels> {
  requireVisibleProcesses(additionalParams);
  const impacts = {};
  const impactsMap = (await getImpacts()).reduce((map, impact) => {
    map.set(impact._id, { _id: impact._id, label: impact.label });
    return map;
  }, new Map<string, LabelledEntity>());

  const filteredIssues = filterIssuesByChartFilters(issues, IssueChart.impact, filters, timezone);

  const reducedToImpactSummary = filteredIssues.reduce<HashMap<number>>(
    (result, issue) => {
      const { impact } = issue.extendedData;

      if (!impact) {
        increaseNoneSeries(result, impacts);
      } else {
        increaseEntitySeries(result, impacts, impactsMap.get(impact)!);
      }
      return result;
    },
    {}
  );

  return toSortedValuesAndLabels(reducedToImpactSummary, impacts);
}
